<template>
    <div class="clients">
        <div class="row">
          <div class="col-sm-6">
            <heading type="h1">Campaigns</heading>
          </div>
        </div>

        Campaigns - not used
        <!-- used?? -->

    </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'Campaigns',
  components: {
    Heading
  },
  data: () => ({}),
  created () {},
  computed: {}
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/campaigns/campaigns.vue